import {
  subscribe
} from "./chunk-W6AJTTKQ.mjs";

// src/hooks/wbk/newsletter/subscribe.ts
import { useMutation } from "@tanstack/react-query";
var useSubscribe = () => {
  return useMutation({
    mutationFn: subscribe
  });
};

export {
  useSubscribe
};
//# sourceMappingURL=chunk-PSGCVUWB.mjs.map